import { useRef, useState, useCallback } from "react";
import { closeLoading, notifyLoading, notifySuccess } from "src/assets/toastService";
import { deleteEmployee, editEmployee, getEmployee, postEmployee } from "src/shared/services/services";
import { ApiResponse, User } from "src/shared/types";
import { errorHandling } from "src/shared/utils/errorHandling";
import { clearUserDetailsFromIndexedDB, deleteUserFromIndexedDB, saveUserToIndexedDB } from "src/shared/utils/indexDB/indexedDB";
import { useUser } from "../components/UserContext";

function useEmployee() {
  const [employee, setEmployee] = useState<User[]>([]);
  const [isLoadingStaff, setIsLoading] = useState<boolean>(false);
  const [fullResponse, setFullResponse] = useState<ApiResponse | null>(null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const { user } = useUser();
  const loginUser = user?.role?.[0] === "User";

  const fetchEmployee = useCallback(() => {
    const token = sessionStorage.getItem("jsonwebtoken");
    if (!token) return;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    setIsLoading(true);

    timerRef.current = setTimeout(() => {
      getEmployee()
        .then(async (res: any) => {
          const employeeTable: ApiResponse = res.data;
          const employeeData: User[] = res.data.result;

          setFullResponse(employeeTable);
          setEmployee(employeeData);
          if (loginUser) await clearUserDetailsFromIndexedDB();
          saveUserToIndexedDB(employeeData);
        })
        .catch((err: any) => {
          errorHandling(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }, 300);
  }, [loginUser]);

  const saveEmployee = (data: any, closeData: () => void, errorData: () => void) => {
    notifyLoading("Please wait, Employee is being saved...");
    postEmployee(data)
      .then((res: any) => {
        closeLoading();
        notifySuccess("Employee saved successfully");
        // fetchEmployee();
        // Removed duplicate fetchEmployee() call here; parent component handles re-fetch via onSuccess
        closeData();
      })
      .catch((err: any) => {
        closeLoading();
        errorHandling(err);
        errorData();
      });
  };

  const changeEmployee = (id: any, data: any, closeData: () => void, errorData: () => void) => {
    notifyLoading("Please wait, Employee is being updating...");
    editEmployee(id, data)
      .then((res: any) => {
        closeLoading();
        notifySuccess("Employee updated successfully");
        // fetchEmployee();
        // Removed duplicate fetchEmployee() call here; parent component handles re-fetch via onSuccess
        closeData();
      })
      .catch((err: any) => {
        closeLoading();
        errorHandling(err);
        errorData();
      });
  };
  // const Refetch = () => {
  //   fetchEmployee();
  // };

  const deleteConfirm = (id: any, closeData: () => void) => {
    deleteEmployee(id)
      .then(async () => {
        await deleteUserFromIndexedDB(String(id));
        closeLoading();
        notifySuccess("Employee deleted successfully");
        // fetchEmployee();
        // Removed duplicate fetchEmployee() call here; parent component handles re-fetch via onSuccess
        closeData();
      })
      .catch((err: any) => {
        closeLoading();
        errorHandling(err);
      });
  };

  return {
    employee,
    fetchEmployee,
    saveEmployee,
    changeEmployee,
    isLoadingStaff,
    Refetch: fetchEmployee,
    deleteConfirm,
    fullResponse,
  };
}

export default useEmployee;